import { render } from "./incident-success.vue?vue&type=template&id=1b952db0&scoped=true"
import script from "./incident-success.vue?vue&type=script&lang=js"
export * from "./incident-success.vue?vue&type=script&lang=js"

import "./incident-success.vue?vue&type=style&index=0&id=1b952db0&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b952db0"]])

export default __exports__